<template>

    <Head title="Domains bearbeiten" />
    <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-primary-100 hover:text-primary-200" href="/domains">Domains</Link>
        <span class="text-primary-100 font-medium">/Bearbeiten</span>
    </h1>
    <!-- Tab List -->
    <ul role="tablist" class="-mb-px flex items-stretch gap-2 text-slate-500 mt-12 mb-6">
        <!-- Tab 1 -->
        <li> <button @click="viewTableId = 1" :aria-selected="viewTableId === 1"
                :class="{ 'bg-primary-100 text-white': viewTableId === 1 }"
                class="flex gap-2 items-center rounded-full px-6 h-10 py-2 text-sm font-medium" role="tab"
                aria-selected="true">

                <span>Massenbearbeitung</span>
            </button> </li>
        <!-- Tab 2 -->
        <li>
            <button @click="viewTableId = 2" :aria-selected="viewTableId === 2"
                :class="{ 'bg-primary-100 text-white': viewTableId === 2 }"
                class="flex gap-2 items-center rounded-full px-6 h-10 py-2 text-sm font-medium" role="tab"
                aria-selected="false">

                <span>Einzeln bearbeiten</span>
            </button>
        </li>
    </ul>
    <div v-if="viewTableId === 1">
        <div
            class="mt-12 mb-12 max-w-lg border-2 p-4 border-primary-100 rounded-md bg-white shadow-md shadow-gray-700/50">
            <h2 class="font-bold mb-4">Folgende Domains werden bearbeitet:</h2>
            <ul>

                <li v-for="domain in form.domains" :key="domain.id" class="flex space-x-3">
                    <span class="flex-shrink-0 h-6 w-2 text-primary-100">></span>
                    <span>
                        {{ domain.domain }}
                    </span>
                </li>
            </ul>
        </div>

        <div class="max-w-3xl bg-white rounded-md shadow">
            <div class="flex flex-wrap p-8">
                <div class="mb-6 w-full">
                    <label class="form-label" for="active">Nächste Rechnung am:</label>
                    <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
                        :enable-time-picker="false" input-class-name="dp-custom-input" v-model="chargedTill"
                        :format="'dd.MM.yy'" locale="de" cancelText="abbrechen"
                        selectText="auswählen"></vue-date-picker>
                </div>
                <div>
                    <button @click="updateAll" class="btn-primary-100 disabled:opacity-35">Update All
                        Domains</button>
                </div>
            </div>
        </div>
    </div>

    <div v-if="viewTableId === 2">
        <h2 class="font-bold mt-4 mb-4">Folgende Domains werden bearbeitet:</h2>
        <ul>

            <li v-for="domain in form.domains" :key="domain.id" class="flex space-x-3">
                <span class="flex-shrink-0 h-6 w-2 text-primary-100">></span>
                <span>
                    {{ domain.domain }}
                </span>
            </li>
        </ul>

        <div v-for="domain in form.domains" :key="domain.id" class="mb-4">
            <form @submit.prevent="update(domain.id)">
                <div class="mb-4">
                    <label for="domain">Domain Name</label>
                    <input v-model="domain.domain" type="text" id="domain" class="form-input"
                        @input="setDirty(domain.id)" />
                </div>
                <div class="mb-4">
                    <label for="active">Active</label>
                    <input v-model="domain.active" type="checkbox" id="active" class="form-checkbox"
                        @input="setDirty(domain.id)" />
                </div>
                <div class="mb-4">
                    <label for="active">Bezahlt bis</label>
                    <vue-date-picker timezone="UTC" :exact-match="true" :start-time="startTime"
                        :enable-time-picker="false" input-class-name="dp-custom-input" v-model="domain.charged_till"
                        :format="'dd.MM.yy'" locale="de" cancelText="abbrechen"
                        selectText="auswählen"></vue-date-picker>
                </div>
                <!-- Add other fields similarly -->
                <button type="submit" class="btn btn-primary-100">Update</button>
            </form>
        </div>
        <button @click="updateAll" class="btn-primary-100 disabled:opacity-35">Update All
            Domains</button>
    </div>

</template>


<script>
import { Head, Link, InertiaLink } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { Inertia } from '@inertiajs/inertia'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
    components: {
        Head,
        Link,
        VueDatePicker,
        InertiaLink
    },
    layout: Layout,
    props: {
        domains: Array,
        customers: Array,
    },
    data() {
        return {
            chargedTill: null, // Single charged_till field
            viewTableId: 1,
            form: {
                domains: this.domains.map(domain => ({
                    ...domain,
                    isDirty: true
                }))
            },
        }
    },
    setup() {
        const startTime = { hours: 0, minutes: 0 };
        return { startTime }
    },
    computed: {
        isDirty() {
            return this.form.domains.some(domain => domain.isDirty);
        }
    },
    methods: {
        update(domainId) {
            const domain = this.form.domains.find(d => d.id === domainId);
            if (domain) {
                Inertia.put(`/domains/${domainId}`, domain, {
                    onSuccess: () => {
                        domain.isDirty = false;
                    },
                    onError: (errors) => {
                        // Handle errors (optional)
                    }
                });
            }
        },
        updateAll() {
            const updatedDomains = this.form.domains.filter(domain => domain.isDirty);

            if (updatedDomains.length > 0) {
                // Update all domains with chargedTill value
                updatedDomains.forEach(domain => {
                    domain.charged_till = this.chargedTill;
                    domain.isDirty = true; // Mark as dirty for update
                });

                Inertia.put('/domains/update-all', { domains: updatedDomains }, {
                    onSuccess: () => {
                        updatedDomains.forEach(domain => domain.isDirty = false);
                    },
                    onError: (errors) => {
                        // Handle errors (optional)
                    }
                });
            }

            if (updatedDomains.length > 0) {
                Inertia.put('/domains/update-all', { domains: updatedDomains }, {
                    onSuccess: () => {
                        updatedDomains.forEach(domain => domain.isDirty = false);
                    },
                    onError: (errors) => {
                        // Handle errors (optional)
                    }
                });
            }
        },
        setDirty(domainId) {

            const domain = this.form.domains.find(d => d.id === domainId);
            console.log(domain);
            if (domain) {
                domain.isDirty = true;
            } else {
                console.error(`Domain with ID ${domainId} not found.`);
            }
        },
    },
}
</script>
